import { C } from '../../theme/palette';

export const FR = ({ label, value, color, bold, last }) => (
  <div
    style={{
      padding: '6px 0',
      borderBottom: last ? 'none' : '1px solid ' + C.border,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 10,
    }}
  >
    <span style={{ fontSize: 9, color: C.muted, flexShrink: 0 }}>{label}</span>
    <span
      style={{
        fontSize: 10,
        fontWeight: bold ? 800 : 600,
        color: color || C.ink,
        textAlign: 'right',
      }}
    >
      {value}
    </span>
  </div>
);
